
/**
* @param condition 
 {
    "type": "auth",
    "role": ["admin"]
}
*/

ConditionalFilters.register("auth", function (entity, condition) {


    console.log("conditionalFilter.auth ", entity, condition)



    return app.authentication.userData.getData().roles.some(role =>  condition.role.includes(role))

   
})